var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11618",
    d: "M14.235 12.668l5.108 3.41-5.108 3.3v-6.709m-1.233-3.88a1.678 1.678 0 00-1.531 1.8v10.829a1.679 1.679 0 001.531 1.8 1.344 1.344 0 00.7-.2l8.919-5.759c1.076-.65 1.091-1.627.035-2.287l-8.935-5.965a1.345 1.345 0 00-.717-.213z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11619",
    d: "M16 2.764A13.236 13.236 0 112.764 16 13.251 13.251 0 0116 2.764M16 0a16 16 0 1016 16A16 16 0 0016 0z"
  }))));
}

export default __webpack_public_path__ + "d295dd6c32e2e0430e77ca9473a7bd32.svg";
export { SvgPlayCircle as ReactComponent };